import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getVendorListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `vendor?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitVendorAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `vendor`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(
      apiUrl + `vendor/add_attachment/` + id,
      body,
      {
        headers: header,
      }
    );
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateVendorAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `vendor/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const  vendorStatusUpdateApi = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `vendor/status_update/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getVendorEditApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `vendor/edit/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVendorDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `vendor/view/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
